import React from 'react';
import './MagazinesSection.css';

const magazines = [
  '/magazines/forbes.webp',
  '/magazines/the-guardian.webp',
  '/magazines/y-combinator.webp',
  '/magazines/the-newyork-times.webp'
];

const MagazinesSection = () => {
  return (
    <section className="magazines-section">
      <div className="container">
        <h2 className="magazines-heading">Our customers are seen on</h2>
        <div className="magazines-logos">
          {magazines.map((src, index) => (
            <img key={index} src={src} alt={`Magazine ${index + 1}`} className="magazine-logo" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MagazinesSection;